// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__naWsI","assetCell":"styles_assetCell__WMMma","priceCell":"styles_priceCell__ijwSM"};